import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../../../src/environments/environment';

import { Router, ActivatedRoute } from '@angular/router';

export interface Article {
  id: number;
  idMenu: number;
  title: string;
  createdBy: string;
  createdDate: string;
  updateBy: string | null;
  updateDate: string | null;
  htmlContent: string;
  textContent: string;
  categorias: { id: number; name: string }[];
  menus: { id: number; name: string }[];
}

@Component({
  selector: 'app-knowledge-base-modal',
  templateUrl: './knowledge-base-modal.component.html',
  styleUrls: ['./knowledge-base-modal.component.scss']
})
export class KnowledgeBaseModalComponent implements OnInit {
  searchQuery = '';
  selectedArticle: Article | null = null;
  articles: Article[] = [];
  isLoading = false;

  constructor(public activeModal: NgbActiveModal, private http: HttpClient,  public router: Router) {}

  ngOnInit() {
    this.loadArticles();
  }

  loadArticles() {
    this.isLoading = true;
    this.http.get<Article[]>(`${environment.apiUrl}/ticket/edit/knowledgebase/`).subscribe(
      (response) => {
        this.articles = response.map(article => ({
          ...article,
          categorias: article.categorias ?? [], // Se for null, define como array vazio
          menus: article.menus ?? []
        }));
        
        this.isLoading = false;
      },
      (error) => {
        console.error('Erro ao carregar artigos:', error);
        this.isLoading = false;
      }
    );
  }

  get filteredArticles() {
    return this.articles.filter(article =>
      article.title.toLowerCase().includes(this.searchQuery.toLowerCase())
    );
  }

 

  openArticle(article: Article) {
    this.activeModal.dismiss();
    this.router.navigateByUrl("/knowledgebase/article/"+article.id+"/edit");
  }

  confirmSelection() {
    if (this.selectedArticle) {
      this.activeModal.close(this.selectedArticle);
    }
  }

  closeModal() {
    this.activeModal.dismiss();
  }
}
